const shop = {
    filters: [],

    /**
     * Initialize.
     *
     */
    init() {
        // Add product to cart
        // $('.color-sets .color-set input').on('change', e => {
        //     $('.actions .button').attr('disabled', false)
        // });
         $('body').on('click', '.actions .button:not(:disabled)', $.proxy(this.addToCart, this));

        // Add custom set to cart
        //$('body').on('click', '.button-confirm.is-active', $.proxy(this.addCustomSetToCart, this));

        // Filters
       // $('#color-picker-popup select').on('change', $.proxy(this.filterOnProductPage, this));
        //$('.product-filters select').on('change', $.proxy(this.filterOnColorsPage, this));

        // Postcode API
        this.getAddress();
        $('#billing_postcode, #billing_address_2').on('blur', $.proxy(this.getAddress, this));
        $(".toggle-address").on('click', $.proxy(this.editAddress, this));

        // Payment
        $('.payment-method input:checked').parents('.payment-method').addClass('is-selected');

        // Account
        $('#coupon').on('click', $.proxy(this.toggleAccountFields, this));

        // Terms and Conditions check
        $('#terms').on('click', $.proxy(this.toggleCheckoutButton, this));


        // Coupon
        $('body').on('click', '#applyCoupon', $.proxy(this.applyCoupon, this));
        $('body').on('click', '.remove-discount a', $.proxy(this.removeCoupon, this));

        // Set new url after removing coupon
        if (location.search && location.search.includes('remove_coupon')) {
            history.pushState({}, null, '/afrekenen/');
        }




    },

    /**
     * Add product with custom set to cart.
     *
     * @param e
     */
    addToCart(e) {

        if ($(".variations")[0]){
            const set = $('.color-set input:checked').val();
            const productId = $("input[name=variation_id]").val();
            const quantity = $('.qty').val() ? $('.qty').val() : 1;

            $.ajax({
                method: 'post',
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                data: {action: 'add_cproduct_to_cart', productId, set, quantity},
                success: res => {
                    $('.cart-icon').show();
                    $('.bag-items .holder').html(res.html);
                    $('.bag-counter').text(res.count);
                    $('.totals-list .total-price').html(res.price);
                    $('.totals-list .shipping-price').html(res.shipping);
                    app.openSidebar();
                }
            });
        } else {
            const set = $('.color-set input:checked').val();
            const productId = $("input[name=product_id]").val();
            const quantity = $('.qty').val() ? $('.qty').val() : 1;

            $.ajax({
                method: 'post',
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                data: {action: 'add_cproduct_to_cart', productId, set, quantity},
                success: res => {
                    $('.cart-icon').show();
                    $('.bag-items .holder').html(res.html);
                    $('.bag-counter').text(res.count);
                    $('.totals-list .total-price').html(res.price);
                    $('.totals-list .shipping-price').html(res.shipping);
                    app.openSidebar();
                }
            });
        }



    },

    /**
     * Add custom set to cart.
     *
     * @param e
     */
    addCustomSetToCart(e) {
        const productId = $('.mnm_cart').data('container_id');
        let colors = [];
        $('.colors .color').each((index, color) => {
            if ($(color).find('input[type="checkbox"]').prop('checked')) {
                colors.push($(color).find('input[type="checkbox"]').val().replace('color', ''));
            }
        });

        $.ajax({
            method: 'post',
            type: "POST",
            url: '/wp-admin/admin-ajax.php',
            data: {action: 'add_cproduct_to_cart', productId, colors},
            success: res => {
                $.fancybox.close();
                $('.bag-items .holder').html(res.html);
                $('.bag-counter').text(res.count);
                $('.totals-list .total-price').html(res.price);
                app.openSidebar();
            }
        });
    },

    /**
     * Filter colors on product page.
     *
     * @param e
     */
    filterOnProductPage(e) {
        const name = $(e.currentTarget).attr('name');
        const value = $(e.currentTarget).val();

        // Add or remove current filter to array
        if (!this.filters.find(filter => filter.name == name)) {
            this.filters.push({name, value});
        } else if (!value) {
            this.filters = this.filters.filter(filter => filter.name != name);
        } else {
            const index = this.filters.findIndex(filter => filter.name == name);
            this.filters[index] = {name, value};
        }

        $('#color-picker-popup .colors .color').each((index, element) => {
            let visible = true;

            for (let filter of this.filters) {
                if (visible) {
                    visible = $(element).data(filter.name).toString().includes(filter.value);
                }
            }

            $(element).toggle(visible);
        });
    },

    /**
     * Filter colors on color page.
     *
     * @param e
     */
    filterOnColorsPage(e) {
        const name = $(e.currentTarget).attr('name');
        const value = $(e.currentTarget).val();

        // Add or remove current filter to array
        if (!this.filters.find(filter => filter.name == name)) {
            this.filters.push({name, value});
        } else if (!value) {
            this.filters = this.filters.filter(filter => filter.name != name);
        } else {
            const index = this.filters.findIndex(filter => filter.name == name);
            this.filters[index] = {name, value};
        }

        this.applyColorFilter();
    },

    /**
     * Apply color filter.
     *
     */
    applyColorFilter() {
        $('.section-product-overview .product-overview .product').each((index, element) => {
            let visible = true;
            for (let filter of this.filters) {
                if (visible) {
                    visible = $(element).data(filter.name).toString().includes(filter.value);
                }
            }
            $(element).toggle(visible);
        });
    },

    /**
     * Toggle postcode API.
     *
     */
    togglePostcodeAPI() {
        const value = $('select#billing_country, select#shipping_country').val();
        const postcode = $('#billing_postcode').val();
        if (value == 'NL') {
            if (postcode) $('.edit-address').show();
            $('.delivery-address').hide();
        } else {
            $('.edit-address').hide();
            $('.delivery-address').show();
        }

        setTimeout(() => {
            $('#billing_address_2').prop('placeholder', '');
            $('#billing_address_1').prop('placeholder', '');
            $('label[for="billing_address_1"]').text('Straatnaam');
        }, 1);
    },

    /**
     * Edit address.
     *
     * @param e
     */
    editAddress(e) {
        // Prevent default behaviour
        if (e) e.preventDefault();
        $('.edit-address').slideToggle();
        $('.delivery-address input').val('');
        $('.delivery-address').slideToggle();
    },

    /**
     * Toggle account fields.
     *
     * @param e
     */
    toggleAccountFields(e) {
        if ($(e.currentTarget).find('input').is(':checked')) {
            $(e.currentTarget).closest('.form-items').find('.checkbox-content').slideDown();
        } else {
            $(e.currentTarget).closest('.form-items').find('.checkbox-content').slideUp();
        }
    },

    /**
     * Toggle checkout button for the Terms of Conditions
     *
     *
     */

    toggleCheckoutButton(e) {
        if ($(e.currentTarget).find('input').is(':checked')) {
            // Remove disabled attribute
            $('#place_order').prop("disabled", false);
            // Remove disabled class
            $('#place_order').removeClass( "disabled" );

        } else {
            // Add disabled attribute
            $('#place_order').prop("disabled", true);
            // Add disabled class
            $('#place_order').addClass( "disabled" );
        }
    },

    /**
     * Apply coupon.
     *
     * @param e
     */
    applyCoupon(e) {
        // Prevent default behaviour
        e.preventDefault();

        $.ajax({
            method: 'post',
            type: "POST",
            url: '/wp-admin/admin-ajax.php',
            data: {action: 'apply_coupon', coupon: $('#coupon').val()},
            success: $.proxy(this.setCouponHTML, this)
        });
    },

    removeCoupon(e) {
        // Prevent default behaviour
        e.preventDefault();

        $.ajax({
            method: 'post',
            type: "POST",
            url: '/wp-admin/admin-ajax.php',
            data: {action: 'remove_coupon', coupon: $('#coupon').val()},
            success: $.proxy(this.setCouponHTML, this)
        });
    },

    setCouponHTML(res) {
        if (res.coupon.success == true) {
            const couponRemove = `(<a href="/afrekenen/?remove_coupon=${res.coupon.code}">Verwijderen</a>)`;
            const couponHTML = `<span>Kortingsbon <small>(${res.coupon.code})</small></span><span>- ${res.coupon.discount}</span>`;
            const couponMessage = ` Kortingscoupon (${res.coupon.code}) is succesvol toegepast!`;
            $('.list.is-small.for-coupon').removeClass('is-hided').html(couponHTML);
            $('.coupon_status.status-success').text(couponMessage).parent().removeClass('is-hided');
            $('.remove-discount').html(couponRemove);
            $('.totals-list .total-price').html(res.price);
        } else if (res.coupon.success == 'deleted') {
            $('.remove-discount').empty();
            $('.coupon_status.status-success').parent().addClass('is-hided');
            $('.list.is-small.for-coupon').addClass('is-hided');
            $('#coupon').val('').removeAttr('disabled').parents('.checkbox-content').removeAttr('style').addClass('is-hided');
            $('#coupon').parents('.form-items').find('input:checkbox').prop('checked', false);
            $('.totals-list .total-price').html(res.price);
            $('#applyCoupon').removeAttr('disabled');
        } else {
            const couponMessage = ` Kortingscoupon wordt niet herkend!`
            $('.coupon_status.status-error').text(couponMessage).parent().removeClass('is-hided');
        }
    },

    /**
     * Get address from postcode.
     *
     * @param e
     */
    getAddress() {
        let postcode = escape($('#billing_postcode').val());
        postcode = postcode ? postcode.replace(' ', '') : postcode;
        let number = escape($('#billing_address_2').val());
        const addition = escape($('#billing_street_addition').val());
        const country = $('select#billing_country, select#shipping_country').val();
        if (country != 'NL') return;

        // Make request only when both filled in
        if (postcode && number) {
            $.ajax({
                type: 'GET',
                url: `https://geodata.nationaalgeoregister.nl/locatieserver/free?fq=postcode:${postcode}&fq=huisnummer~${number}*`,
                success: res => {
                    if (res.response.docs.length) {
                        $('.postcode-error').hide();
                        $('.delivery-address').hide();

                        const address = res.response.docs[0];
                        $('.formatted-address').html(`${address.straatnaam} ${number} ${addition} <br> ${postcode} ${address.woonplaatsnaam}`);

                        $('#billing_address_1').val(address.straatnaam);
                        $('#billing_city').val(address.woonplaatsnaam);

                        $('.formatted-address').parents('.is-full').show();
                    } else {
                        $('.postcode-error').show();
                        this.editAddress();
                    }
                },
                error: error => {
                    console.log(error);
                }
            });
        }
    },

    /**
     * Set correct shipping costs.
     *
     */
    setCorrectShippingCosts() {
        $.ajax({
            method: 'post',
            type: "POST",
            url: '/wp-admin/admin-ajax.php',
            data: {action: 'get_mini_cart'},
            success: res => {
                $('.totals-list .total-price').html(res.price);
                $('.totals-list .shipping-price').html(res.shipping);
            }
        });
    }
};

module.exports = shop;